import React, { Component } from 'react';

var BlockR = React.createClass({
  handlerChangeStatus: function(){
    this.props.actionSelect(this.props.id, this.props.filter);
  },
  render: function(){
    return(
      <div onClick={this.handlerChangeStatus} className={"blockR" + (this.props.select !== false && this.props.select == this.props.id ? ' active' : '')}>{this.props.name}</div>
    );
  }
});

export default BlockR;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/Filter/BlockR/index.jsx
 **/